const imagePaths = {
    "2005": Array.from({ length: 30 }, (_, i) =>
      require(`./2005/${i + 1}.png`)
    ),
    "2007": Array.from({ length: 32 }, (_, i) =>
      require(`./2007/${i + 1}.png`)
    ),
    "2008": Array.from({ length: 36 }, (_, i) =>
      require(`./2008/${i + 1}.png`)
    ),
    "2009": Array.from({ length: 32 }, (_, i) =>
      require(`./2009/${i + 1}.png`)
    ),
    "2010": Array.from({ length: 32 }, (_, i) =>
      require(`./2010/${i + 1}.png`)
    ),
    "2011": Array.from({ length: 32 }, (_, i) =>
      require(`./2011/${i + 1}.png`)
    ),
    "2012": Array.from({ length: 32 }, (_, i) =>
      require(`./2012/${i + 1}.png`)
    ),
    "2013": Array.from({ length: 36 }, (_, i) =>
      require(`./2013/${i + 1}.png`)
    ),
    "2014": Array.from({ length: 36 }, (_, i) =>
      require(`./2014/${i + 1}.png`)
    ),
    "2015": Array.from({ length: 36 }, (_, i) =>
      require(`./2015/${i + 1}.png`)
    ),

    "2016": Array.from({ length: 36 }, (_, i) =>
        require(`./2016/${i + 1}.png`)
      ),

    "2018": Array.from({ length: 36 }, (_, i) =>
        require(`./2018/${i + 1}.png`)
      ),
    "2019": Array.from({ length: 36 }, (_, i) =>
      require(`./2019/${i + 1}.png`)
    ),
    "2020": Array.from({ length: 36 }, (_, i) =>
      require(`./2020/${i + 1}.png`)
    ),
    "2022": Array.from({ length: 32 }, (_, i) =>
      require(`./2022/${i + 1}.png`)
    ),
    "2023": Array.from({ length: 44 }, (_, i) =>
      require(`./2023/${i + 1}.png`)
    ),
    "2024": Array.from({ length: 36 }, (_, i) =>
      require(`./2024/${i + 1}.png`)
    ),
    "2025": Array.from({ length: 44 }, (_, i) =>
      require(`./2025/${i + 1}.png`)
    ),
    "2026": Array.from({ length: 40 }, (_, i) =>
      require(`./2026/${i + 1}.png`)
    ),
  };
  
  export default imagePaths;
  